import { Routes } from '@angular/router';
import { ResultPageComponent } from './process-shell/result-page/result-page.component';




/** Home module childs */
export var componentRoutes: Routes = [

  // {
  //   path: 'transactions',
  //   loadChildren: () => import('src/app/Accounts/Accounts.module').then((m) => m.AccountsModule),
  //   data: { animation: 'fadeInAnimation' },
  // },

  // {
  //   path: 'transfers',
  //   loadChildren: () => import('src/app/retail/transfers-ui/transfers-ui.module').then((m) => m.TransfersUiModule)
  // },

  {
    path: 'bbn',
    loadChildren: () => import('src/app/bbn/bbn.module').then((m) => m.BbnModule),
    data: { animation: 'fadeInAnimation' },
  },
  {
    path: 'dedupe',
    loadChildren: () => import('src/app/dedupe/dedupe.module').then((m) => m.DedupeModule),
    data: { animation: 'fadeInAnimation' },
  },
  {
    path: 'result',
    component: ResultPageComponent
  },
 
  

];

export var preloginComponentRoutes: Routes = [
  {
    path: "",
    loadChildren: () => import('src/app/pre-login/login/login.module').then(m => m.LoginModule)
  }

];

export var accountsComponentRoutes: Routes = [
  

];




export class AppRoutingModule {}
